import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './contact10.css'
import { useTranslation } from 'react-i18next';

const Contact10 = ({
  content1 = undefined,
  location2ImageSrc = './images/contacts/mercaditoai-app.jpg',
  location1ImageSrc = './images/contacts/sandiego.jpg',
  location1Description = undefined,
  location2ImageAlt = 'Teléfono de contacto',
  heading1 = undefined,
  location2Description = undefined,
  location1ImageAlt = 'Oficina principal',
  location1 = undefined,
  location2 = undefined,
}) => {
  const { t } = useTranslation();

  return (
    <div className="contact10-container1 thq-section-padding">
      <div className="contact10-max-width thq-section-max-width">
        <div className="contact10-content1 thq-flex-row">
          <div className="contact10-content2">
            <h2 className="thq-heading-2">
              {heading1 ?? (
                <Fragment>
                  <span className="contact10-text18">{t('home.contact.heading')}</span>
                </Fragment>
              )}
            </h2>
            <p className="thq-body-large">
              {content1 ?? (
                <Fragment>
                  <span className="contact10-text16">
                    {t('home.contact.content')}
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>
        <div className="contact10-content3 thq-flex-row">
          <div className="contact10-container2">
            <img
              alt={location1ImageAlt}
              src={location1ImageSrc}
              className="contact10-image1 thq-img-ratio-16-9"
            />
            <h3 className="contact10-text12 thq-heading-3">
              {location1 ?? (
                <Fragment>
                  <span className="contact10-text20">
                    {t('home.contact.location')}
                  </span>
                </Fragment>
              )}
            </h3>
            <p className="thq-body-large">
              {location1Description ?? (
                <Fragment>
                  <span className="contact10-text17">
                    {t('home.contact.locationInfo')}
                  </span>
                </Fragment>
              )}
            </p>
            <div className="contact10-container3">
              <a
                href="https://example.com"
                target="_blank"
                rel="noreferrer noopener"
                className="thq-button-flat thq-body-small"
              >
                {t('home.contact.locationMap')}
              </a>
            </div>
          </div>
          <div className="contact10-container4">
            <img
              alt={location2ImageAlt}
              src={location2ImageSrc}
              className="contact10-image2 thq-img-ratio-16-9"
            />
            <h3 className="contact10-text14 thq-heading-3">
              {location2 ?? (
                <Fragment>
                  <span className="contact10-text21">{t('home.contact.phone')}</span>
                </Fragment>
              )}
            </h3>
            <p className="thq-body-large">
              {location2Description ?? (
                <Fragment>
                  <span className="contact10-text19">
                    {t('home.contact.phoneInfo')}
                  </span>
                </Fragment>
              )}
            </p>
            <div className="contact10-container5">
              <a
                href="https://example.com"
                target="_blank"
                rel="noreferrer noopener"
                className="thq-button-flat thq-body-small"
              >
                {t('home.contact.phoneBot')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Contact10.propTypes = {
  content1: PropTypes.element,
  location2ImageSrc: PropTypes.string,
  location1ImageSrc: PropTypes.string,
  location1Description: PropTypes.element,
  location2ImageAlt: PropTypes.string,
  heading1: PropTypes.element,
  location2Description: PropTypes.element,
  location1ImageAlt: PropTypes.string,
  location1: PropTypes.element,
  location2: PropTypes.element,
}

export default Contact10
